<template>
  <div class="led-screen">
    <!-- 顶部标题栏 -->
    <div class="led-header">
      <div class="header-side left-side">
        <span class="date">{{ nowDate }}</span>
        <span class="week">{{ nowWeek }}</span>
      </div>
      <div class="header-title">
        <span class="title-text">{{ pageTitle }}</span>
        <div class="title-decoration"></div>
      </div>
      <div class="header-side right-side">
        <span class="time">{{ nowTime }}</span>
      </div>
    </div>

    <!-- 主体区 -->
    <div class="led-body">
      <!-- 顶部数据统计区 -->
      <div class="stats-section">
        <!-- 核心指标卡片 -->
        <div class="stats-cards">
          <div class="stat-card">
            <div class="stat-icon">🏢</div>
            <div class="stat-content">
              <div class="stat-value">{{ stats.companyCount }}</div>
              <div class="stat-label">招聘企业数</div>
            </div>
          </div>
          <div class="stat-card">
            <div class="stat-icon">💼</div>
            <div class="stat-content">
              <div class="stat-value">{{ stats.jobCount }}</div>
              <div class="stat-label">在招岗位数</div>
            </div>
          </div>
          <div class="stat-card">
            <div class="stat-icon">¥</div>
            <div class="stat-content">
              <div class="stat-value">{{ stats.avgSalary }}</div>
              <div class="stat-label">平均薪资(元/月)</div>
            </div>
          </div>
          <div class="stat-card">
            <div class="stat-icon">👥</div>
            <div class="stat-content">
              <div class="stat-value">{{ stats.totalPositions }}</div>
              <div class="stat-label">招聘总人数</div>
            </div>
          </div>
        </div>

        <!-- 学历分布 -->
        <div class="edu-panel">
          <div class="panel-title-row">
            <span class="panel-title-main">
              <span class="title-icon">📚</span>
              学历要求分布
            </span>
            <span class="panel-subtitle">实时数据统计</span>
          </div>
          <div class="edu-bars">
            <div class="edu-item" v-for="(item, idx) in eduDistribution" :key="idx">
              <div class="edu-name">{{ item.name }}</div>
              <div class="edu-track">
                <div class="edu-fill" :style="{ width: item.percent + '%' }">
                  <span class="edu-count">{{ item.count }}岗</span>
                </div>
              </div>
              <div class="edu-percent">{{ item.percent }}%</div>
            </div>
          </div>
        </div>
      </div>

      <!-- 滚动岗位列表 -->
      <div class="job-panel">
        <div class="job-panel-header">
          <span class="panel-title">最新招聘岗位</span>
          <span class="panel-count">共 {{ totalCount }} 条</span>
        </div>
        <div class="job-list-head">
          <span class="col col-company">企业名称</span>
          <span class="col col-job">招聘岗位</span>
          <span class="col col-num">人数</span>
          <span class="col col-edu">学历</span>
          <span class="col col-salary">薪资</span>
<!--          <span class="col col-industry">行业</span>-->
        </div>
        <div class="job-list-viewport" ref="viewport">
          <div class="job-list-scroller"
               ref="scroller"
               :style="scrollerStyle">
            <div class="job-row"
                 v-for="(row, idx) in displayList"
                 :key="idx">
              <span class="col col-company" :title="row.C_Cname">{{ row.C_Cname || '-' }}</span>
              <span class="col col-job" :title="row.Jobname">{{ row.Jobname || '-' }}</span>
              <span class="col col-num">{{ row.Jnum || '-' }}</span>
              <span class="col col-edu">{{ row.Jeducation_CN || row.Jeducation || '不限' }}</span>
              <span class="col col-salary highlight">{{ row.Jsalary_CN || row.Jsalary || '面议' }}</span>
<!--              <span class="col col-industry">{{ row.Industry || '不限' }}</span>-->
            </div>
            <div class="job-empty" v-if="!displayList.length">
              <span>暂无岗位数据</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部状态栏 -->
    <div class="led-footer">
      <span class="footer-text">数据实时更新 · 太仓市人力资源市场 · 真诚服务每一位求职者</span>
    </div>
  </div>
</template>

<script>
import {getJobfairJobList, getjoblist} from '@/api/scinfo/scinfo'

export default {
  name: 'led_recruitment_stats',
  data () {
    return {
      pageTitle: '太仓高新区人力资源服务中心',

      // 数据
      jobList: [],
      totalCount: 0,
      pageNum: 1,
      pageSize: 888,

      // 统计数据
      stats: {
        companyCount: 0,
        jobCount: 0,
        avgSalary: '0',
        totalPositions: 0
      },

      // 分布数据
      eduDistribution: [],

      // 时间
      nowDate: '',
      nowTime: '',
      nowWeek: '',

      // 滚动
      scrollOffset: 0,
      scrollTimer: null,
      refreshTimer: null,
      clockTimer: null,
      viewportHeight: 0,
      contentHeight: 0
    }
  },
  computed: {
    // 数据不足时复制一份保证滚动首尾衔接
    displayList () {
      if (!this.jobList.length) return []
      if (this.jobList.length < 10) {
        const arr = []
        const times = Math.ceil(20 / this.jobList.length)
        for (let i = 0; i < times; i++) arr.push(...this.jobList)
        return arr
      }
      return [...this.jobList, ...this.jobList]
    },
    scrollerStyle () {
      return {
        transform: `translateY(${-this.scrollOffset}px)`
      }
    }
  },
  methods: {
    // 拉岗位数据
    loadJobs () {
      getJobfairJobList(2721,this.pageNum, this.pageSize).then(res => {
        if (res && res.data && res.data.code === 0) {
          this.jobList = res.data.data || []
          this.totalCount = res.data.count || this.jobList.length
          this.calculateStats()
          this.$nextTick(() => {
            this.recalcScrollSize()
            this.scrollOffset = 0
          })
        }
      }).catch(() => {})
    },

    // 计算统计数据
    calculateStats () {
      const list = this.jobList
      if (!list.length) return

      // 企业数（去重）
      const companies = new Set(list.map(item => item.C_Cname).filter(Boolean))
      this.stats.companyCount = companies.size

      // 岗位数
      this.stats.jobCount = list.length

      // 招聘总人数
      this.stats.totalPositions = list.reduce((sum, item) => {
        const num = parseInt(item.Jnum) || 0
        return sum + num
      }, 0)

      // 平均工资（解析薪资范围取中间值）
      let totalSalary = 0
      let salaryCount = 0
      list.forEach(item => {
        const salary = item.Jsalary_CN
        if (salary && salary !== '面议') {
          const match = salary.match(/(\d+)-(\d+)/)
          if (match) {
            const min = parseInt(match[1])
            const max = parseInt(match[2])
            totalSalary += (min + max) / 2
            salaryCount++
          }
        }
      })
      this.stats.avgSalary = salaryCount > 0 ? Math.round(totalSalary / salaryCount).toLocaleString() : '-'

      // 学历分布
      const eduMap = {}
      list.forEach(item => {
        const edu = item.Jeducation_CN || item.Jeducation || '不限'
        eduMap[edu] = (eduMap[edu] || 0) + 1
      })
      this.eduDistribution = Object.entries(eduMap)
        .map(([name, count]) => ({ name, count, percent: Math.round((count / list.length) * 100) }))
        .sort((a, b) => b.count - a.count)
        .slice(0, 5)
    },

    recalcScrollSize () {
      if (this.$refs.viewport) {
        this.viewportHeight = this.$refs.viewport.clientHeight
      }
      if (this.$refs.scroller) {
        this.contentHeight = this.$refs.scroller.scrollHeight
      }
    },

    // 匀速滚动
    startScroll () {
      this.stopScroll()
      this.scrollTimer = setInterval(() => {
        if (!this.jobList.length) return
        this.scrollOffset += 0.5
        const half = this.contentHeight / 2
        if (half > 0 && this.scrollOffset >= half) {
          this.scrollOffset = 0
        }
      }, 30)
    },
    stopScroll () {
      if (this.scrollTimer) {
        clearInterval(this.scrollTimer)
        this.scrollTimer = null
      }
    },

    // 时钟
    updateClock () {
      const now = new Date()
      const pad = n => (n < 10 ? '0' + n : '' + n)
      this.nowDate = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`
      this.nowTime = `${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`
      const weeks = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
      this.nowWeek = weeks[now.getDay()]
    }
  },
  mounted () {
    this.updateClock()
    this.clockTimer = setInterval(this.updateClock, 1000)
    this.loadJobs()

    this.refreshTimer = setInterval(() => {
      this.loadJobs()
    }, 60 * 1000)

    setTimeout(() => {
      this.recalcScrollSize()
      this.startScroll()
    }, 1500)

    this._resizeHandler = () => this.recalcScrollSize()
    window.addEventListener('resize', this._resizeHandler)
  },
  beforeDestroy () {
    this.stopScroll()
    if (this.refreshTimer) clearInterval(this.refreshTimer)
    if (this.clockTimer) clearInterval(this.clockTimer)
    if (this._resizeHandler) window.removeEventListener('resize', this._resizeHandler)
  }
}
</script>

<style lang="less" scoped>
@primaryBg: #0A0F1F;
@panelBg: rgba(15, 30, 60, 0.6);
@accentColor: #00E4FF;
@textPrimary: #E8F4FF;
@textSecondary: #7C9CBF;

.led-screen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background: @primaryBg;
  background-image:
    radial-gradient(ellipse at top, rgba(0, 100, 200, 0.25) 0%, transparent 60%),
    radial-gradient(ellipse at bottom, rgba(0, 50, 120, 0.2) 0%, transparent 60%),
    linear-gradient(180deg, #050914 0%, #0A0F1F 50%, #050914 100%);
  color: @textPrimary;
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
  display: flex;
  flex-direction: column;
  user-select: none;
}

/* 顶部标题栏 */
.led-header {
  height: 80px;
  padding: 0 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid rgba(0, 228, 255, 0.15);
  position: relative;
  flex-shrink: 0;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 10%;
    right: 10%;
    height: 1px;
    background: linear-gradient(90deg, transparent, @accentColor, transparent);
    opacity: 0.6;
  }

  .header-side {
    display: flex;
    align-items: center;
    gap: 16px;
    color: @textSecondary;
    font-size: 20px;
    min-width: 320px;

    .date { color: @textPrimary; letter-spacing: 2px; }
    .time { color: @accentColor; font-size: 26px; font-weight: 500; letter-spacing: 3px; }
    .week { color: @textSecondary; }
  }
  .left-side { justify-content: flex-start; }
  .right-side { justify-content: flex-end; }

  .header-title {
    flex: 1;
    text-align: center;
    position: relative;

    .title-text {
      font-size: 36px;
      font-weight: 700;
      letter-spacing: 6px;
      background: linear-gradient(180deg, #FFFFFF 0%, @accentColor 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      text-shadow: 0 0 20px rgba(0, 228, 255, 0.3);
    }
    .title-decoration {
      margin: 4px auto 0;
      width: 320px;
      height: 6px;
      background: linear-gradient(90deg, transparent, @accentColor 50%, transparent);
      opacity: 0.7;
    }
  }
}

/* 主体 */
.led-body {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 20px 40px;
  gap: 20px;
  min-height: 0;
}

/* 数据统计区 */
.stats-section {
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  gap: 24px;
  align-items: stretch;
}

/* 统计卡片 */
.stats-cards {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, 1fr);
  gap: 16px;
  flex: 1;
  min-width: 0;
}

.stat-card {
  background: @panelBg;
  border: 1px solid rgba(0, 228, 255, 0.25);
  border-radius: 8px;
  padding: 16px 20px;
  display: flex;
  align-items: center;
  gap: 12px;
  box-shadow: inset 0 0 40px rgba(0, 100, 200, 0.15), 0 4px 20px rgba(0, 0, 0, 0.3);

  .stat-icon {
    font-size: 40px;
    opacity: 0.8;
  }

  .stat-content {
    flex: 1;

    .stat-value {
      font-size: 36px;
      font-weight: 700;
      color: @accentColor;
      text-shadow: 0 0 20px rgba(0, 228, 255, 0.4);
      line-height: 1.2;
    }

    .stat-label {
      font-size: 14px;
      color: @textSecondary;
      margin-top: 2px;
      letter-spacing: 1px;
    }
  }
}

/* 学历分布面板 */
.edu-panel {
  background: @panelBg;
  border: 1px solid rgba(0, 228, 255, 0.25);
  border-radius: 8px;
  padding: 16px 24px;
  box-shadow: inset 0 0 40px rgba(0, 100, 200, 0.15);
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;

  .panel-title-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 12px;
    border-bottom: 1px solid rgba(0, 228, 255, 0.2);
    margin-bottom: 16px;
    flex-shrink: 0;

    .panel-title-main {
      display: flex;
      align-items: center;
      gap: 8px;
      font-size: 20px;
      font-weight: 600;
      color: @accentColor;
      letter-spacing: 3px;

      .title-icon {
        font-size: 22px;
      }
    }

    .panel-subtitle {
      font-size: 14px;
      color: @textSecondary;
    }
  }

  .edu-bars {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 12px;
  }

  .edu-item {
    display: flex;
    align-items: center;
    gap: 12px;

    .edu-name {
      width: 100px;
      font-size: 14px;
      color: @textSecondary;
      text-align: right;
      flex-shrink: 0;
    }

    .edu-track {
      flex: 1;
      height: 28px;
      background: rgba(0, 228, 255, 0.1);
      border-radius: 14px;
      overflow: hidden;
      position: relative;
    }

    .edu-fill {
      height: 100%;
      background: linear-gradient(90deg, @accentColor, #4CAF50);
      border-radius: 14px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding-right: 10px;
      transition: width 1s ease-out;
      min-width: 40px;

      .edu-count {
        font-size: 13px;
        color: #fff;
        white-space: nowrap;
      }
    }

    .edu-percent {
      width: 45px;
      font-size: 15px;
      color: @accentColor;
      font-weight: 600;
      text-align: right;
      flex-shrink: 0;
    }
  }
}

/* 岗位面板 */
.job-panel {
  flex: 1;
  min-width: 0;
  background: @panelBg;
  border: 1px solid rgba(0, 228, 255, 0.25);
  border-radius: 8px;
  padding: 20px 24px 24px;
  display: flex;
  flex-direction: column;
  box-shadow: inset 0 0 40px rgba(0, 100, 200, 0.15);

  .job-panel-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 14px;
    border-bottom: 1px solid rgba(0, 228, 255, 0.2);

    .panel-title {
      font-size: 26px;
      font-weight: 600;
      color: @accentColor;
      letter-spacing: 4px;
      text-shadow: 0 0 10px rgba(0, 228, 255, 0.5);

      &::before {
        content: '';
        display: inline-block;
        width: 4px;
        height: 24px;
        background: @accentColor;
        vertical-align: middle;
        margin-right: 12px;
        border-radius: 2px;
      }
    }
    .panel-count {
      color: @textSecondary;
      font-size: 18px;
      letter-spacing: 2px;
    }
  }

  .job-list-head, .job-row {
    display: flex;
    align-items: center;
    padding: 0 10px;

    .col {
      padding: 0 8px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .col-company  { flex: 2.5; }
    .col-job      { flex: 2.5; }
    .col-num      { flex: 0.8; text-align: center; }
    .col-edu      { flex: 1; text-align: center; }
    .col-salary   { flex: 1.2; text-align: center; }
    .col-industry { flex: 1.2; text-align: center; }
  }

  .job-list-head {
    height: 50px;
    margin-top: 10px;
    background: linear-gradient(90deg, rgba(0, 228, 255, 0.15), rgba(0, 100, 200, 0.05));
    border-radius: 3px;
    color: @accentColor;
    font-size: 18px;
    letter-spacing: 2px;
    font-weight: 500;
    flex-shrink: 0;
  }

  .job-list-viewport {
    flex: 1;
    overflow: hidden;
    position: relative;
    margin-top: 8px;

    .job-list-scroller {
      will-change: transform;
      transition: none;
    }

    .job-row {
      height: 52px;
      font-size: 18px;
      color: @textPrimary;
      border-bottom: 1px dashed rgba(0, 228, 255, 0.1);

      &:nth-child(odd) {
        background: rgba(0, 228, 255, 0.03);
      }

      .col-salary.highlight {
        color: #FFD54F;
        font-weight: 600;
        text-shadow: 0 0 8px rgba(255, 213, 79, 0.3);
      }

      .col-industry {
        color: #81D4FA;
      }
    }

    .job-empty {
      padding: 60px 0;
      text-align: center;
      color: @textSecondary;
      font-size: 22px;
    }
  }
}

/* 底部 */
.led-footer {
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: @textSecondary;
  letter-spacing: 6px;
  font-size: 16px;
  border-top: 1px solid rgba(0, 228, 255, 0.15);
  flex-shrink: 0;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 10%;
    right: 10%;
    height: 1px;
    background: linear-gradient(90deg, transparent, @accentColor, transparent);
    opacity: 0.4;
  }
}
</style>
